require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");


require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/limarquee.js");

require("./custom/header.es6");
require("./custom/scroll-trigger.es6");
require("./custom/popup.es6");
require("./vendor/cursor.js");


(function ($) {
    $(".section-hero").length > 0 && require("./page-builder/section_hero.es6");
    $(".section-move-logotypes").length > 0 && require("./page-builder/section_move_logotypes.es6");
    $(".section-info-blocks").length > 0 && require("./page-builder/section_info_blocks.es6");
    $(".section-info-blocks-type-2").length > 0 && require("./page-builder/section_info_blocks_type_2.es6");
    $(".section-text-with-slider").length > 0 && require("./page-builder/section_text_with_slider.es6");
    $(".section-tabs").length > 0 && require("./page-builder/section_tabs.es6");
    $(".section-tabs-type-2").length > 0 && require("./page-builder/section_tabs_type_2.es6");
    $(".image-slider").length > 0 && require("./custom/image-slider.es6");
    $(".section-leadership").length > 0 && require("./page-builder/section_leadership.es6");
    $(".section-newsroom").length > 0 && require("./page-builder/section_newsroom.es6");
    $(".share-box").length > 0 && require("./custom/share.es6");

    if ($(".section-info-collapse").length > 0) {
        require("./vendor/TweenMax.min.js");
        require("./vendor/parallax_content.js");
        require("./page-builder/section_info_collapse.es6");
    }

    if ($(".section-image-with-text").length > 0) {
        require("./vendor/TweenMax.min.js");
        require("./vendor/parallax_content.js");
        require("./page-builder/section_image_with_text.es6");
    }
})(jQuery);